import apiClient from "api/client/axios.client";

   
export interface NoticeHeaderAddDto {
  albumId?: string | null;
  categoryId?: string | null;
  title?: string | null;
  description?: string | null;
  noticeState: number;
  shipping: number;
  expirationDays: number;
  forceSupply: number;
  
}

export interface NoticeSectionUpdateDto {
  noticeId?: string | null;
  key?: string | null;
  value?: string | null;
 
}

export interface NoticeHeaderGetDto {
  id: string;
}


export const addNotice = async (
  data: NoticeHeaderAddDto
): Promise<NoticeHeaderGetDto> => {
  const response = await apiClient.post<NoticeHeaderGetDto>(
    "/Notice/v1/NoticeHeader/External/Add",
    data
  );
  // بسته به ساختار ریسپانس بک‌اند، ممکن است نیاز باشد response.data.data یا مشابه آن برگردانده شود
  return response.data; 
};


export const UpdateSection = async (
  data: NoticeSectionUpdateDto
): Promise<NoticeHeaderGetDto> => {
  const response = await apiClient.post<NoticeHeaderGetDto>(
    "/Notice/v1/NoticeHeader/External/UpdateSection",
    data
  );
  // بسته به ساختار ریسپانس بک‌اند، ممکن است نیاز باشد response.data.data یا مشابه آن برگردانده شود
  return response.data; 
};